import React, {useContext, useEffect, useState} from "react";
import {Swiper, SwiperSlide} from "swiper/react";
import SwiperCore, {Navigation, Zoom, Pagination, Scrollbar, A11y} from "swiper";
import 'swiper/swiper-bundle.min.css'
import 'swiper/swiper.min.css'
import BottomButtonWrapper from "../../components/BottomButtonWrapper";
import Button from "../../components/newComponents/button/Button";
import {createSearchParams, useLocation, useNavigate, useSearchParams} from "react-router-dom";
import {AiOutlineArrowLeft, AiOutlineArrowRight} from "react-icons/ai";
import DepositCard from "../../components/tosan/DepositCard";
import {Reoverlay} from "reoverlay";
import ErrorModal from "../../components/tosan/modals/ErrorModal";
import DataContext from "../../tools/contexts/tosan/DataContext";
import HeaderCard from "../../components/tosan/HeaderCard";
import BillTypes from "../../tools/defaults/tosan/billTypes";
import Skeleton from "react-loading-skeleton";
import getDeposit from "../../tools/api/tosan/getDeposit";
import LoadingModal from "../../components/tosan/modals/LoadingModal";
import genUuid from "../../tools/api/tosan/genUuid";
import doBillPayment from "../../tools/api/tosan/doBillPayment";
import useAxiosCancel from "../../tools/hoc/useAxiosCancel";

const GetDeposits = () => {
    const navigate = useNavigate();
    const dataContext = useContext(DataContext);
    const [searchParams] = useSearchParams();
    const parameter = searchParams.get('parameter');
    const serviceType = searchParams.get('serviceType');
    const formattedPrice = new Intl.NumberFormat('fa-IR');
    const [loading, setLoading] = useState(true);
    const [deposits, setDeposits] = useState([]);
    const {state} = useLocation();
    const {processData} = state;
    const [activeDeposit, setActiveDeposit] = useState(0);
    const getCancelToken=useAxiosCancel();
    SwiperCore.use([Navigation, Zoom, Pagination, Scrollbar, A11y]);
    useEffect(() => {
        handleGetDeposits()
    }, [])
    const handleGetDeposits = async () => {
        const cancelToken=getCancelToken();
        setLoading(true)
        const params = {
            pid: processData.pid,
        }
        const response = await getDeposit(dataContext.token, params,cancelToken);
        setLoading(false)
        if (response.isOk) {
            setDeposits(response?.data?.deposits || [])
        } else {

            if(!response.canceled)
            Reoverlay.showModal(ErrorModal, {
                title: 'خطا',
                message: response.message,
                showCancelButton: true,
                cancelButtonTheme: "danger",
                cancelButtonText: response.status === 870 || response.status === 802 ? 'بازگشت به لیست قبض‌ها' : 'تلاش مجدد',
                onCancel: () => {

                    if (response.status === 870 || response.status === 802) {
                        Reoverlay.hideModal();
                        navigate('/tosan/' + serviceType)
                    } else {
                        Reoverlay.hideModal();
                        handleGetDeposits();
                    }


                }

            })
        }
    }


    const handleDoBillPayment = async () => {
        const cancelToken=getCancelToken();
        Reoverlay.showModal(LoadingModal, {
            text: 'لطفا منتظر بمانید'
        });
        const response = await genUuid(dataContext.token, {
            request_type: 'DoBillPayment',
            callback_url: "https://venesh.ir"
        },cancelToken);

        if (response.isOk) {

            if (response.data.uuid) {
                const params = {
                    uuid: response.data.uuid,
                    pid: processData.pid,
                    DepositNumber: activeDeposit.deposit_number,
                };
                const doBillPaymentResponse = await doBillPayment(dataContext.token, params);
                Reoverlay.hideModal();
                if (doBillPaymentResponse.isOk) {
                    navigate({
                        pathname: `/tosan/paymentReceipt`,
                        search: createSearchParams({
                            rrn: doBillPaymentResponse.data.data.rrn,
                            tracking_number: doBillPaymentResponse.data.data.tracking_number,
                            date: doBillPaymentResponse.data.date,
                            price: doBillPaymentResponse.data.amount,
                            billType: doBillPaymentResponse.data.bill_type,
                            parameter: doBillPaymentResponse.data.bill_param,
                            billId: doBillPaymentResponse.data.bill_id,
                            payId: doBillPaymentResponse.data.bill_pay_id,
                        }).toString()
                    })
                } else {
                    Reoverlay.showModal(ErrorModal, {
                        title: 'خطا',
                        message: doBillPaymentResponse.message,
                        showCancelButton: true,
                        cancelButtonTheme:"danger",
                        cancelButtonText: doBillPaymentResponse.status === 877 ? 'بازگشت به لیست قبض‌ها' : 'بستن',
                        onCancel: () => {
                            Reoverlay.hideModal()
                            if (doBillPaymentResponse.status === 877) {
                                navigate('/tosan/' + serviceType)
                            }

                        }

                    })

                }
            } else {
                Reoverlay.hideModal();
            }
        } else {
            Reoverlay.hideModal();

            if(!response.canceled)
            Reoverlay.showModal(ErrorModal, {
                title: 'خطا',
                message: response.message,
                cancelButtonTheme: "danger",
                onCancel: () => {
                    handleDoBillPayment();
                    Reoverlay.hideModal()
                }
            })
        }
    }
    const handleBack = () => {
        navigate(-1)
    }

    return <div>
        <HeaderCard hasBack={false} onBack={handleBack}
                    className="flex justify-center default-header-card flex-col items-center ">
            <h1 className="title">پرداخت قبض </h1>
        </HeaderCard>
        {loading && <div className="w-11/12 mt-3 mx-auto">
            <Skeleton baseColor="#E5E5E5" height={150} count={1}/>
        </div>}
        {!loading && <>
            <div className="w-full lg:w-6/12  mx-auto">
                {deposits.length > 0 && <div
                    className="w-full overflow-x-hidden flex-col items-center flex justify-center justify-center mt-3 ">

                    <div className="w-11/12 relative  mx-auto">
                        <Swiper
                            // install Swiper modules
                            modules={[Navigation, Pagination, Scrollbar, A11y]}
                            spaceBetween={10}

                            breakpoints={
                                {
                                    0: {
                                        slidesPerView: 1,
                                        spaceBetween: 3,
                                    },
                                    // when window width is >= 480px
                                    480: {
                                        slidesPerView: 1,
                                        spaceBetween: 3
                                    },
                                    // when window width is >= 640px
                                    640: {
                                        slidesPerView: 1,
                                        spaceBetween: 3
                                    }
                                }
                            }
                            navigation={{
                                nextEl: '.btn-next-swiper',
                                prevEl: '.btn-prev-swiper',
                            }}

                            direction="horizontal"
                            slidesPerView={2}
                            onSwiper={(swiper) => setActiveDeposit(deposits[swiper.activeIndex])}
                            onSlideChange={(swiper) => setActiveDeposit(deposits[swiper.activeIndex])}
                        >
                            {deposits.map((deposit, index) => <SwiperSlide key={'deposit_key' + index}
                                                                           className="flex justify-center">
                                <DepositCard billAmount={state?.billInfo?.Amount} deposit={deposit}/>
                            </SwiperSlide>)}


                        </Swiper>
                        <button className="btn-next-swiper">
                            <AiOutlineArrowLeft className="text-lg"/></button>
                        <button className="btn-prev-swiper ">
                            <AiOutlineArrowRight className="text-lg"/></button>
                    </div>

                </div>}

            </div>
            <BottomButtonWrapper>
                <div className="w-full text-sm flex justify-between mb-1 items-center">
                    <span>{BillTypes[serviceType].parameterLabel}</span>
                    <span
                        className="  ">{parameter}</span>
                </div>
                <div className="w-full text-sm flex justify-between items-center">
                    <span>مبلغ پرداختی</span>
                    <span
                        className=" font-bold text-green-500"> {formattedPrice.format(+state?.billInfo?.Amount?.value)} ریال  </span>
                </div>
                <div className="flex grid grid-cols-2 mt-1 pt-2 border-t">
                    <Button onClick={handleBack}  type="button" rounded="rounded" className={'w-full'} theme="link">بازگشت</Button>
                    <Button disabled={activeDeposit.balance - state?.billInfo?.Amount?.value <= 0}
                            onClick={handleDoBillPayment} theme="success" rounded="rounded">
                        پرداخت
                    </Button>
                </div>
            </BottomButtonWrapper>
        </>}
    </div>
}
export default GetDeposits;